export default "Properly size images\n|||\nThe images are too small and not responsive.\n|||\nImages should have a fixed height and wight.\n";